import { axiosApi } from '@accor/customer-core'
import { API_LATAM_PLANS } from '@/constants/urls'
import { type Rrule } from '@/stores/user'
import { logger } from '@/services/logger'

export interface Latam {
  items: LatamPlan[]
}

export interface PricingOption {
  rrule: Rrule
  amount: number
  currency: string
  pricing_option_id: string
}

export interface LatamPlan {
  plan_code: string
  pricing_options: PricingOption[]
}

export const getLatamPlans = async () => {
  try {
    const { data } = await axiosApi.get(`${API_LATAM_PLANS}?active=true`)
    return data as Latam
  } catch (err) {
    logger.error(err)
  }
}
